import React, { useEffect } from "react";
import { useReactFlow } from "reactflow";

//* Import Helper
import {
  getId,
  initialNode,
  findFirstMissingNumber,
} from "../utilities/helper";

//* Import Utils
import nodeUtils from "../utilities/nodeUtils";

const PaneMenu = ({ top, left, gameNumbers, hasWorkingTeam, ...props }) => {
  const { unSelectNodes } = nodeUtils();
  const { addNodes, screenToFlowPosition } = useReactFlow();

  const addTextNode = (event) => {
    addNodes({
      id: getId(),
      type: "titleNode",
      position: screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      }),
      data: {
        title: "",
      },
    });
  };

  const addGameNode = async (event, direction, type = "defaultNode") => {
    const { newNumber } = findFirstMissingNumber(gameNumbers);
    const targetPosition = direction === "RL" ? "right" : "left";
    const sourcePosition = direction === "RL" ? "left" : "right";

    //* Deselect the old selected node
    unSelectNodes();

    addNodes({
      id: getId(),
      type,
      position: screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      }),
      data: {
        ...initialNode.data,
        ...(hasWorkingTeam
          ? {
              hasWorkingTeam: hasWorkingTeam,
              team_3_of_type: "",
              team_3_of_type_label: "",
              team_3_of_type_value: "",
              team_3_cancelled: true,
            }
          : {}),
        game_number: newNumber,
      },
      targetPosition,
      sourcePosition,
      selected: true,
    });
  };

  return (
    <div style={{ top, left }} className="contextMenu" {...props}>
      <button onClick={(e) => addGameNode(e, "LR")}>Add Game (L-{">"}R)</button>
      <button onClick={(e) => addGameNode(e, "RL")}>Add Game (R-{">"}L)</button>
      <button onClick={(e) => addGameNode(e, "RL", "compassNode")}>
        Add Compass Game
      </button>
      <button onClick={addTextNode}>Add Text</button>
    </div>
  );
};

export default PaneMenu;
